import React from 'react';
import { IErrorBoundaryState } from './types';
import { Container } from 'react-bootstrap';

class ErrorBoundary extends React.Component<any, IErrorBoundaryState> {
  state = { error: null };

  componentDidCatch(error: Error, errorInfo: Object) {
    this.setState({ error });
    console.log('Error Boundary...');
    console.error(error);
  }

  render() {
    if (this.state.error === null) {
      return this.props.children;
    }

    return (
      <Container>
        <h1>An unexpected error has occurred</h1>
      </Container>
    );
  }
}

export default ErrorBoundary;
